import { Getters } from 'vuex-smart-module';
import CoursesRequestsState from './state';

export default class CoursesRequestsGetters extends Getters<CoursesRequestsState> {}
